import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { ButtonRedSecondary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { LittleModalCreateEditOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalDeleteFilledOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { Fragment } from 'react'
import CustomSelect from '../../../../../../../../forms/CustomSelect'

interface ConfigShift4CustomRenderProps {
    parameters: TwinParameters
    getData: () => Promise<void>
}

export const ConfigShift4CustomRender: React.FC<ConfigShift4CustomRenderProps> = ({ parameters, getData }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    let myRender = <ConfigureShift4 setOpenModal={setOpenModal} />
    if (parameters?.shift4CompanyName) {
        myRender = <ConfiguratedShift4 setOpenModal={setOpenModal} parameters={parameters} />
    }
    return (
        <Fragment>
            {myRender}
            {openModal?.type === 'edit' ? <ModalShift4ParametersConfig onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
            {openModal?.type === 'delete' ? <ModalDeleteShift4ConfigQuote onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
        </Fragment>
    )
}

interface ConfiguratedShift4Props {
    setOpenModal: SetEditDeleteModalTy
    parameters: TwinParameters
}

const ConfiguratedShift4: React.FC<ConfiguratedShift4Props> = ({ setOpenModal, parameters }) => {
    const { t } = useTwinTranslation()
    const onOff = {
        'on': { name: t('on', 'Activado') },
        'off': { name: t('disabledS', 'Desactivado') },
    }
    return (
        <div className='gap-10 flex flex-row items-end mt-minus20'>
            <div className='flex gap-x-10 items-center'>
                <TwinTrans transKey={'shift4Configured'}>Shift4 configurado</TwinTrans>
                <ButtonRedSecondary className='w-fit ml-10' type='button' onClick={() => setOpenModal({ type: 'delete', allRowData: {} })} key={'deleteShift4Config'}><TwinTrans transKey={'deleteShift4Config'}>Borrar configuración de Shift4</TwinTrans></ButtonRedSecondary>
            </div>
            <CustomSelect name='shift4Test' className='min-w-210 w-200' label={t('shift4TestMode', 'Modo pruebas Shift4')} items={onOff} value={parameters.shift4Test || 'on'} />
            <CustomSelect name='shift4AutoRefund' className='min-w-210 w-200' label={t('shift4AutoRefund', 'Devoluciones automáticas Shift4')} items={onOff} value={parameters.shift4AutoRefund} />
        </div>
    )
}

interface ConfigureShift4Props {
    setOpenModal: SetEditDeleteModalTy
}
const ConfigureShift4: React.FC<ConfigureShift4Props> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <span><TwinTrans transKey={'shift4ParametersConfig'}>Configurar parámetros de Shift4</TwinTrans>:</span>
            <ButtonSecondary className='w-fit' type='button' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })} key={'configShift4'}><TwinTrans transKey={'Config'}>Configurar</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ModalDeleteShift4ConfigQuoteProps extends ModalEditComponentProps { }

export const ModalDeleteShift4ConfigQuote: React.FC<ModalDeleteShift4ConfigQuoteProps> = ({ setOpened, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/parameter/deleteParameters',
        data: {
            parameters: ['shift4AuthToken', 'shift4ClientGuid', 'shift4AccessToken', 'shift4CompanyName', 'shift4AutoRefund']
        }
    })

    return (
        <ModalDeleteFilledOutside opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteShift4Config', '¿Seguro que quieres borrar la configuración de Shift4?'),
            subtitle: t('YouWillBeAbleToConfigItAgain', 'Podrás volver a configurarla de nuevo'),
            buttonAccept: t('delete', 'Borrar'),
        }} />
    )
}

interface ModalShift4ParametersConfigProps extends ModalEditComponentProps { }

export const ModalShift4ParametersConfig: React.FC<ModalShift4ParametersConfigProps> = ({ setOpened, onSubmit }: ModalShift4ParametersConfigProps) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<TwinEmployeeParametersDict> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'shift4AuthToken',
                    label: t('shift4AuthToken', 'Auth Token de Shift4'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'shift4ClientGuid',
                    label: t('shift4ClientGuid', 'Client Guid de Shift4'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'shift4CompanyName',
                    label: t('shift4CompanyName', 'Nombre de empresa de Shift4'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
            ]
        },
    ]
    return (
        <LittleModalCreateEditOutside className={'flex flex-col'} fields={fields} setOpened={setOpened} url={'/api/app/config/parameter/updateParameters'} translations={{
            title: t('parameters', 'Parámetros'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} onSubmit={onSubmit} />
    )
}